<template>
  <div class=event-blocks>
    <div v-bind:key="event_item.id" v-for="event_item in event_items">
      <EventBlock v-bind:event_item="event_item" v-on:date-change="dateChange" v-on:delete-event="deleteEvent" v-on:error-alert="logError" v-on:name-change="eventNameChange" :id="event_item.id" :field_names="field_names"></EventBlock>
    </div>
    <!-- <input type="submit" v-on:click="viewData" value="View Data" class="button"/> -->
  </div>
</template>

<script>
import EventBlock from '@/components/EventBlock.vue'

export default {
  name: 'Events',
  props: ["event_items", "field_names"],
  components: {
    EventBlock
  },
  methods: {
    dateChange(obj) {
      this.$emit('date-change', obj);
    },
    deleteEvent(id) {
      this.$emit('delete-event', id);
    },
    logError(obj) {
      this.$emit('error-alert', obj);
    },
    eventNameChange(obj) {
      this.$emit('name-change', obj);
    }
  }
}
</script>

<style scoped>
.event-blocks {
  padding: 0.5rem;
}
</style>
